import { useEffect } from "react"
import { emit, EVENTS, useTelemetry } from "../event-emitter"
import { extractText } from "../utils"

/**
 * Emits telemetry when the modal is mounted.
 *
 * @param {Object} props - Data to send alongside the event.
 */
export function useModalTelemetry({ telemetry, ...props }) {
  const telemetryPayload = useTelemetry(telemetry)

  useEffect(() => {
    if (telemetryPayload === false) return

    emit(EVENTS.MODAL_OPEN, {
      label: extractText(props.label),
      ariaLabel: extractText(props.ariaLabel),
      ...telemetryPayload
    })

    // We're intentionally using an empty dependency array to emit telemetry
    // only once when the modal mounts. This is enforced by a test. Ignoring
    // the warning is intentional and safe.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
